var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', {
    staticClass: "mb-40 mb-lg-80",
    attrs: {
      "show-arrows": ""
    },
    on: {
      "change": _vm.push
    },
    model: {
      value: _vm.query['employment.types'],
      callback: function callback($$v) {
        _vm.$set(_vm.query, 'employment.types', $$v);
      },
      expression: "query['employment.types']"
    }
  }, [_vm._l(_vm.items, function (_ref) {
    var text = _ref.text,
      value = _ref.value;
    return [_c('v-chip', _vm._b({
      key: value,
      staticClass: "justify-center",
      attrs: {
        "x-large": "",
        "active-class": "primary"
      }
    }, 'v-chip', {
      value: value
    }, false), [_vm._v(" " + _vm._s(text))])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }